import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

class Salesdonut extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: "bottom",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
            },
          },
        },
        colors: ["#626ed4", "#02a499", "#38a4f8", "#f8b425", "#ff4560", "#93b4a1"],
        labels: ["Cash", "Kunal (ICICI Savings)", "Poornima (CCBL)", "Poornima (HDFC)", "Kunal (HUF)", "Kunal (ICICI Current)"],
      },
    };
  }

  render() {
    return (
      <ReactApexChart
        options={this.state.options}
        series={this.props.series}
        type="donut"
        height="350"
      />
    );
  }
}

export default Salesdonut;